import { TranslationActionType } from './translation.actionCreators';
import { RESOLVE_SUCCESS } from './translation.actionTypes';

export type TranslationLabelValue = {
	de?: string;
	fr?: string;
	it?: string;
};

export type TranslationProcessedValue = {
	map: {
		de: string;
		fr: string;
		it: string;
	};
	label: string;
};

export type TranslationStateType = {
	map: {
		[label: string]: TranslationLabelValue;
	};
	error?: Error;
};

export type RootStateType = {
	translation: TranslationStateType;
};

export const initialState: TranslationStateType = {
	map: {},
};

export default (state: TranslationStateType = initialState, action: TranslationActionType) => {
	switch (action.type) {
		case RESOLVE_SUCCESS:
			const { map, label } = action.translations;

			return {
				...state,
				map: {
					...state.map,
					[label]: map,
				},
			};
		default:
			return state;
	}
};
